import React from "react";
import { FaFingerprint } from "react-icons/fa";

function ContactUs() {

    return (
        <>
            <section id="contact_us" className="contact_us_sec bg_dark page-section bg_img">
                <div className="container-xl">
                    {/* desktop or tablet view */}
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                                <h2 className="sec_title">Contact Us :</h2>
                            </div>
                            <div className="gs_b gs_fr">
                                <div className="gs_fr_top d-flex align-items-center justify-content-between me-0">
                                    <div className="gab_title">
                                        <div className="gab_icon">
                                            <img src={require('../../assets/images/005-call.png')} alt="" />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Phone</h5>
                                        </div>
                                    </div>
                                    <a href="tel:(805) 650-1534" className="c_action_link">(805) 650-1534</a>
                                </div>
                            </div>
                            <div className="gs_b gs_fr">
                                <div className="gs_fr_top d-flex align-items-center justify-content-between me-0">
                                    <div className="gab_title">
                                        <div className="gab_icon">
                                            <img src={require('../../assets/images/001-email.png')} alt="" />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Email</h5>
                                        </div>
                                    </div>
                                    <a href="mailto:info@foreward.golf" className="c_action_link">info@foreward.golf</a>
                                </div>
                            </div>
                            <div className="gs_b gs_fr">
                                <div className="gs_fr_top d-flex align-items-center justify-content-between me-0">
                                    <div className="gab_title">
                                        <div className="gab_icon">
                                            <img src={require('../../assets/images/003-globe.png')} alt="" />
                                        </div>
                                        <div className="gab_text">
                                            <h5>Socials</h5>
                                        </div>
                                    </div>
                                    <div className="p-0">
                                        <a href="https://www.facebook.com/ForewardGolfCo/" target="_blank" className="c_action_link me-3"><i className="bi bi-facebook" /></a>
                                        <a href="https://www.instagram.com/foreward.golf/" target="_blank" className="c_action_link me-3"><i className="bi bi-instagram" /></a>
                                        <a href="https://www.youtube.com/@ForewardGolf" target="_blank" className="c_action_link"><i className="bi bi-youtube" /></a>
                                        {/* <a href="#" target="_blank" className="c_action_link"><i className="bi bi-twitter" /></a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 c_info_part">
                            <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                                <h2 className="sec_title">Visit Us :</h2>
                            </div>
                            <div className="gs_b gs_fr">
                                <div className="row align-items-center">
                                    <div className="col-lg-6 gx-footer">
                                        <div className="gs_fr_top d-flex align-items-center justify-content-between">
                                            <div className="gab_title">
                                                <div className="gab_icon">
                                                    <img src={require('../../assets/images/038-location.png')} alt="" />
                                                </div>
                                                <div className="gab_text">
                                                    <h5>Location</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="cc_text">
                                            <span className="c_action_link mb-4 d-block">
                                                5917 Olivas Park Dr. Suite A Ventura, California 93003
                                            </span>
                                            <span className="c_action_link d-block">
                                                <b>Mon - Fri :  </b> 9am to 6pm <br />
                                                <b>Saturday :  </b> 10am to 2pm <br />
                                                <b>Sunday :  </b> Closed
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ratio ratio-1x1 map_radio ">
                                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3298.2442469501634!2d-119.20799638441409!3d34.24231071513646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80e84d1262384ecb%3A0x56c811a8a00ad805!2s6019%20Olivas%20Park%20Dr%20c%2C%20Ventura%2C%20CA%2093003%2C%20USA!5e0!3m2!1sen!2sin!4v1645707837044!5m2!1sen!2sin" width={600} height={450} style={{ border: 0 }} allowFullScreen loading="lazy" /> */}
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3298.234372979849!2d-119.20918002368361!3d34.24256270765587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80e852a83d08dbdb%3A0x2d1ee9bca88666a!2sForeward%20Golf!5e0!3m2!1sen!2sin!4v1712579715684!5m2!1sen!2sin" width={600} height={450} style={{ border: 0 }} allowFullScreen loading="lazy"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* desktop or tablet view */}
                    {/* <a href="#" className="btn btn_default bg-darkest text-white show_mobile_f m-auto mt-5 show_tab_f">Contact Us</a> */}
                </div>
            </section>

        </>
    );
}

export default ContactUs;